import React, { Component, useState, useRef } from "react";
import { getBlogData, updateBlog, emptyBlog } from "../../Actions/BlogActions";
import { connect } from "react-redux";
import base64 from "base-64";
import utf8 from "utf8";
import OuterHeader from "../Layout/OuterHeader";
import InnerHeader from "../Layout/InnerHeader";
import Dashboard from "../Dashboard";
import Footer from "../Layout/Footer";
import { Redirect } from "react-router-dom";
import PublishDate from "../Layout/PublishDate";
import { Button, Dropdown } from "semantic-ui-react";
import UploadImageWithoutDropZone from "../S3Uploading/UploadImageWithoutDropZone";
import UploadImage from "../S3Uploading/UploadImage";
import { Editor } from '@tinymce/tinymce-react';

import { getBlogCategories } from "../../Actions/BlogCategoryAction";

import JoditEditor from "jodit-react";


import { post } from 'axios';

/* Routes */
import { SIGN_IN, ALL_BLOGS } from '../../routes';

class EditBlog extends Component {
  state = {
    image: "",
    title: "",
    description: "",
    publishDate: "",
    blogHTML: "",
    blog_id: 0,
    date: "",
    time: "",
    blogCategoryId: "",
    editorImage: ''

  };


  componentDidMount() {
    this.props.getBlogCategories();
    if (!this.props.auth.uid) {
      return <Redirect to={SIGN_IN} />;
    } else {
      let id = this.props.match.params.id;
      this.props.getBlogData(id);
      this.setState({ blog_id: id });
    }
  }

  componentWillReceiveProps(nextprop) {
    let blog = nextprop.blog;
    const blocksFromHtml = base64.decode(blog.blog_html);
    const blocksFromHtmlUTF8 = utf8.decode(blocksFromHtml);
    this.setState({
      blogHTML: blocksFromHtmlUTF8
    });
    if (blog.blogCategoryId !== undefined) {
      this.setState({ blogCategoryId: blog.blogCategoryId.id });
    }
    this.setState({
      title: blog.title,
      image: blog.image,
      description: blog.description,
      publishDate: blog.publishDate
    });
    console.log(blog.publishDate);
  }

  getPublishDate(publishDateTime) {
    if (publishDateTime) {
      this.setState({ publishDate: publishDateTime });
    }
  }
  getImageUrl(image) {
    if (image) {
      this.setState({ image: image });
    }
  }

  getEditorImage(imageUrl) {
    if (imageUrl) {

      if (imageUrl === "delete") {
        this.setState({ editorImage: '' });

      } else {
        this.setState({ editorImage: imageUrl });
      }
    }
  }


  handleBlogCategoryChange = (e, { value }) => {
    this.setState({ blogCategoryId: value });
  };

  handleChange = e => {
    switch (e.target.name) {
      default:
        this.setState({ [e.target.name]: e.target.value });
    }
  };
  handleSubmit = e => {

    const {
      blog_id,
      blogHTML,
      title,
      image,
      description,
      publishDate, blogCategoryId
    } = this.state;

    console.log("before edit")
    console.log(blogHTML)

    var res = blogHTML;

    if (blogHTML.includes('<img') === true) {
      res = res.split('<img').join('<img style="display: block; margin-left: auto; margin-right: auto;  text-align: center;  line-height: 96px; height: 22%; color: gray; border: 1px solid rgba(34, 36, 38, .15);border-radius: .28571429rem; transition: box-shadow .1s ease, border-color .1s ease, -webkit-box-shadow .1s ease; object-fit: scale-down"');
    }

    // if (blogHTML.includes('<figcaption') === true) {
    //   res = res.split('<figcaption').join('<figcaption style="text-align: center"');
    // }

    // let html = "<div dir='rtl' lang='ar'>" + res + "</div>"

    let html = res;

    if (image === '' || image === undefined || image === null || image === 'null') {
      alert("please insert image");
      this.setState({
        validateInput: false
      })
    }

    else if (blogCategoryId === '' || blogCategoryId === null || blogCategoryId === undefined) {
      alert("please choose blog category");
      this.setState({
        validateInput: false
      })
    }
    else if (title === '' || title === null || title === undefined) {
      alert("please insert title");
      this.setState({
        validateInput: false
      })
    }
    else if (blogHTML === '' || blogHTML === undefined || blogHTML === null) {

      alert("post can't be empty");
      this.setState({
        validateInput: false
      })
    }
    else if (publishDate === '' || publishDate === undefined || publishDate === null) {
      alert("publish date can't be empty");
      this.setState({
        validateInput: false
      })
    }
    else if (description === '' || description === undefined || description === null) {
      alert("description can't be empty");
      this.setState({
        validateInput: false
      })
    }
    else {
      console.log("html")
      console.log(html)
      this.props.updateBlog(
        blog_id,
        title,
        description,
        image,

        html,

        publishDate, blogCategoryId
      );
    }
    e.preventDefault();
  };

  handleEditorChange = (content, editor) => {
    // console.log('Content was updated:', content);
    this.setState({
      blogHTML: content
    });
  }

  render() {


    const
      config = {
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        defaultActionOnPaste: "insert_clear_html",
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        enableDragAndDropFileToEditor: true,
        useImageResizer: false,
        direction: 'rtl',
      }


    const { blogCategories } = this.props;
    const { blogerror, blogsucess } = this.props;
    const blogCategoriesList = [];
    for (let i = 0; i < blogCategories.length; i++) {
      blogCategoriesList.push({
        key: blogCategories[i].id,
        text: blogCategories[i].categoryText,
        value: blogCategories[i].id
      });
    }
    if (blogsucess === false) {
      alert("error messing data or network " + blogerror);
      this.props.emptyBlog();
    } else if (blogsucess === true) {
      alert("blog updated Successfully");
      this.props.emptyBlog();
      return <Redirect to={ALL_BLOGS} />;
    }

    return (
      <div className="container">
        <OuterHeader />
        <div className="container">
          <div className="container-body">
            <div className="row">
              <Dashboard />
              <div className="col-9">
                <InnerHeader />
                <div className="main-content">
                  <div className="row">
                    <div className="col-12 left-main-body" id="left-main-body">
                      <h5 className="main-title mt-2 font-weight-bold">
                        <span> Edit Blog</span>
                      </h5>
                      <br />
                      <div className="container">
                        <form onSubmit={this.handleSubmit}>
                          <label className="small-label">
                            <span className="required_input">*</span>
                            post image</label>

                          <br />
                          <UploadImageWithoutDropZone
                            getImageURLCallBack={this.getImageUrl.bind(this)}
                            imagepreview={this.state.image}
                            imageUrl={this.state.image}
                            s3DirectryrName='blog'
                          />
                          <label className="small-label">
                            <span className="required_input">*</span>
                            Blog Category</label>{" "}
                          <br />
                          <Dropdown
                            placeholder="select blog category"
                            selection
                            onChange={this.handleBlogCategoryChange}
                            options={blogCategoriesList}
                            value={this.state.blogCategoryId}
                          />
                          <br /> <br />
                          <label className="small-label">
                            <span className="required_input">*</span>
                            post title</label>
                          <input
                            dir="auto"
                            className="form-control"
                            type="text"
                            id="title"
                            name="title"
                            onChange={this.handleChange}
                            value={this.state.title}
                          />
                          <br />
                          <div className="form-group">
                            <label
                              className="small-label"
                              for="exampleFormControlTextarea1"
                            ><span className="required_input">*</span>
                              Description
                            </label>
                            <textarea
                              dir="auto"
                              className="form-control"
                              id="exampleFormControlTextarea1"
                              rows="3"
                              name="description"
                              onChange={this.handleChange}
                              value={this.state.description}
                            />
                          </div>
                          <br />

                          <label className="small-label">
                            Editor Upload Image </label>
                          <UploadImage
                            getImageURLCallBack={this.getEditorImage.bind(this)}
                            imageUrl={this.state.editorImage}
                            imagepreview={this.state.editorImage}
                            s3DirectryrName='blog'
                          />
                          <br />
                          <label className="small-label">
                            Editor Image Url</label>

                          <input
                            className="form-control"
                            type="text"
                            value={this.state.editorImage}
                          />
                          <br />


                          <label className="small-label">
                            <span className="required_input">*</span>
                            post</label>


                          {/* <div>
                            <JoditEditor
                              config={config}
                              value={this.state.blogHTML}
                              /** NGMA-2403 
                              onBlur={newContent =>
                                this.setState({blogHTML: newContent.target.innerHTML})
                              } // preferred to use only this option to update the content for performance reasons
                            />
                          </div> */}
                          <div>
                            <Editor
                              onInit={(evt, editor) => {

                                const body = editor.dom.select('body')[0];
                                editor.dom.add(
                                  body,
                                  'script',
                                  {
                                    src: "https://cdn.jsdelivr.net/npm/jquery@3.5.1/dist/jquery.slim.min.js",
                                    type: 'text/javascript'
                                  }
                                );

                                editor.dom.add(
                                  body,
                                  'script',
                                  {
                                    src: "https://cdn.jsdelivr.net/npm/bootstrap@4.6.1/dist/js/bootstrap.bundle.min.js",
                                    type: 'text/javascript'
                                  }
                                );
                              }}
                              initialValue={this.state.blogHTML}
                              onBlur={newValue => {
                                this.setState({ blogHTML: newValue.target.getContent() })
                              }}
                              // onEditorChange={newValue => {
                              //   this.setState({ blogHTML: newValue.target.innerHTML })
                              // }}
                              init={{

                                height: 500,
                                plugins: [
                                  "advlist autolink lists link image charmap print preview anchor",
                                  "searchreplace visualblocks code fullscreen",
                                  "insertdatetime media table paste"
                                ],
                                toolbar: "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image",
                                content_css: "https://cdn.jsdelivr.net/npm/bootstrap@4.6.1/dist/css/bootstrap.min.css, https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css",
                                valid_children: '+body[style]',
                                valid_elements: '*[*]',
                                inline_styles: true,
                                extended_valid_elements: 'i[class]',
                                width: '100%'

                              }}
                            />
                          </div>

                          <br /> <br />
                          <PublishDate
                            getPublishDateCallBack={this.getPublishDate.bind(this)}
                            date={this.state.publishDate}
                          />
                          <br /> <br />
                          <Button
                            icon
                            labelPosition="right"
                            id="nextButton"
                            onClick={this.handleSubmit}
                          >
                            Publish
                          </Button>
                          <br />
                          <br /> <br />
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  blog: state.blogs.item,
  blogerror: state.blogs.error_updating_blog,
  blogsucess: state.blogs.blog_updated_successfully,
  auth: state.firebase.auth,
  blogCategories: state.blogCategories.items
});
export default connect(
  mapStateToProps,
  { getBlogData, updateBlog, emptyBlog, getBlogCategories }
)(EditBlog);
